import { render, staticRenderFns } from "./ConfirmMsgboxModal.vue?vue&type=template&id=2cf9306d"
import script from "./ConfirmMsgboxModal.vue?vue&type=script&lang=js"
export * from "./ConfirmMsgboxModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports